module.exports = __webpack_public_path__ + "img/phase2.e9ce9ab7.png";